// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderBundleInfoOverlay_container__2cuu6","link":"HeaderBundleInfoOverlay_link__3YbjL"};